<template>
  <div class="jd-section jd-section--duty">
    <p class="job-section__header">{{ $t('jobDetail.jobDuty') }}</p>
    <p>{{ jobDescription || $t('general.notAvailable') }}</p>
  </div>
</template>

<script>
export default {
  props: {
    jobDescription: {
      default: '',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
p {
  @apply whitespace-pre-wrap break-words;
}
</style>
